import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { MapPin, X, Loader2 } from 'lucide-react';
import { resetTemporaryCoordinates } from '../../slices/locationSlice';

const TemporaryLocationBanner = ({ tempLocationName }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleReset = async () => {
    setIsLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(resetTemporaryCoordinates());
    } catch (error) {
      console.error('Error resetting location:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {tempLocationName && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="overflow-hidden"
        >
          <div className="bg-blue-600 text-white">
            <div className="max-w-5xl mx-auto px-4 py-2.5">
              <div className="flex items-center justify-between gap-3">
                {/* Location Info */}
                <div className="flex items-center gap-2.5 min-w-0 flex-1">
                  <MapPin className="w-4 h-4 flex-shrink-0" />
                  <p className="text-sm font-medium truncate">
                    <span className="opacity-90">{t('viewing_from', 'Viewing from')}: </span>
                    <span className="font-semibold">{tempLocationName}</span>
                  </p>
                </div>

                {/* Reset Button */}
                <button
                  onClick={handleReset}
                  disabled={isLoading}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-white/20 hover:bg-white/30 
                             rounded-lg text-sm font-medium transition-colors flex-shrink-0
                             disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isLoading ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <X className="w-4 h-4" />
                  )}
                  <span className="hidden sm:inline">
                    {t('reset', 'Reset')}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TemporaryLocationBanner;
